/**
 * Example formats:
 * Lan:0011621F80AD = StarIO
 * 10.80.10.103 = EpsonSocket
 * BT:mC_Print3 = StarPrint
 * USB:mC_Print3 = StarPrint
 *
 * @param id The ID/address of the printer
 */
export function assumePrinterType(id: string): 'EpsonSocket' | 'StarIO' | 'StarPrint' | null {
  if (id.toLowerCase().startsWith('lan:')) {
    return 'StarIO';
  }

  if (id.includes('.')) {
    return 'EpsonSocket';
  }

  if (id.startsWith('BT:') || id.startsWith('USB:')) {
    return 'StarPrint';
  }

  return null;
}

/**
 * The ID of the printer is in this format:
 * 192.168.68.237|cl10w8yluqc9g081720tvvewe
 *
 * Return just the IP part
 */
export function getPrinterID(id: string) {
  return id.split('|')[0];
}
